import { createSlice } from "@reduxjs/toolkit";
import { locale } from "configs/default-features";

const slice = createSlice({
  name: "language",
  initialState: {
    data: {},
    language: locale,
  },
  reducers: {
    changeLanguage(state, { payload }) {
      state.language = payload;
      localStorage.setItem("locales", JSON.stringify(state.language));
    },
  },
});

export const { changeLanguage } = slice.actions;

export default slice.reducer;
